// extracted by mini-css-extract-plugin
module.exports = {"body":"_2sjY_HAyl99zSS41N5diKh","dialog":"_3rLD1ZBzSJP1eaZqwY4snk"};